/**
 * Question Controller
 */
class QuestionController {
    constructor(recoveryPasswordService, $scope, $uibModal, $state, $stateParams) {
        'ngInject';
        //Exposing globals to another methods
        this.recoveryPasswordService = recoveryPasswordService;
        this.$scope = $scope;
        this.$uibModal = $uibModal;
        this.$state = $state;
        this.securityQuestions = angular.copy($stateParams.securityQuestions);
        this.question = {};
        this.questionQualifier = null;
        if (this.securityQuestions) {
            this.configureQuestionQualifier();
            this.selectRandomQuestion();
        }
        this.loading = false;
        if(!this.question.possibleAnswers || this.question.possibleAnswers.length == 0){
            this.$state.go('token');
        }
    }

    configureQuestionQualifier() {
        let count = this.securityQuestions.questions.filter((q) => {
            return q.selectedAnswer !== null;
        }).length + 1;
        this.questionQualifier = count + ' - ';
    }

    selectRandomQuestion() {
        let showIdentityQuestion = sessionStorage.getItem('showIdentityQuestion');
        let unansweredQuestions = this.securityQuestions.questions.filter((q) => {
            return q.selectedAnswer === null;
        });

        if(!showIdentityQuestion){
            var indexOfIdentityQuestion = 1;
            unansweredQuestions.splice(indexOfIdentityQuestion, 1)
            sessionStorage.setItem('showIdentityQuestion', true)
        }

        let length = unansweredQuestions.length;
        this.question = unansweredQuestions[new Date().getTime() % length];

        let answeredQuestions = this.securityQuestions.questions.filter((q) => {
            return q.selectedAnswer !== null;
        });

        if (length > 2) {
            angular.forEach(answeredQuestions, function(val, key){
                if((val.type==='BANK_AGENCY_NUMBER' || val.type==='BANK_ACCOUNT_NUMBER') && (this.question.type==='BANK_AGENCY_NUMBER' || this.question.type==='BANK_ACCOUNT_NUMBER')){
                    this.question = unansweredQuestions[(new Date().getTime() % (length-1))];
                }
            }, this);
        }

        if (!this.question.selectedAnswer)
            this.question.selectedAnswer = {description: null};
    }

    async checkAnsweredSecurityQuestions() {
        this.loading = true;
        let count = this.securityQuestions.questions.filter((q) => {
            return q.selectedAnswer !== null;
        }).length;
        
        let result;
        result = await this.recoveryPasswordService.checkAnsweredSecurityQuestion(this.securityQuestions).catch(e => result = e);
        if(count===1){
            if (result.status === 200) {
                this.$state.go('question', {securityQuestions: this.securityQuestions})
            } else if ([400, 401, 403].contains(result.status)){
                this.showAnswersModal(result.status);
            }
        }else{
            if (result.status === 200) {
                this.$state.go("password");
            } else if ([400, 401, 403].contains(result.status)){
                this.showAnswersModal(result.status);
            }
            this.$scope.$apply();
        }
        this.loading = false;
    }

    async sendToServer() {
        let result;
        result = await this.recoveryPasswordService.checkAnsweredSecurityQuestion(this.securityQuestions).catch(e => result = e);
        if (result.status === 200) {
            this.$state.go("password");
        } else if ([400, 401, 403].contains(result.status))
            this.showAnswersModal(result.status);
        this.loading = false;
        this.$scope.$apply();
    }

    /**
     * 40X - Error Notification Modal
     */
    showAnswersModal(code) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            templateUrl: 'invalidAnswers.modal.html',
            controllerAs: '$ctrl',
            size: 'sm',
            controller: ($scope, code) => {
                "ngInject";
                let $ctrl = $scope.$ctrl;

                $ctrl.code = code;
                $ctrl.ok = () => {
                    modalInstance.close();
                };
            },
            resolve: {
                code: () => code
            }
        });

        modalInstance.result.then(() => {
            if (code > 400)
                this.$state.go("login")
        }, () => {
            if (code > 403)
                this.$state.go("login")
        });
    };
}

export default QuestionController;


// WEBPACK FOOTER //
// ./src/app/components/views/question/question.controller.js